import React from "react";

// Full-screen "Currently Under Maintenance" page shown by App when the API
// cannot reach its databases (issue #77). Intentionally self-contained with
// inline styles and no data dependencies so it renders even when the backend
// is fully unavailable.
const wrapStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: "24px",
    backgroundColor: "#f4f6f9",
    color: "#2f3b52",
    fontFamily: "Segoe UI, Roboto, Helvetica, Arial, sans-serif",
    zIndex: 9999
};

const headingStyle = { fontSize: "28px", fontWeight: 600, margin: "0 0 12px" };
const bodyStyle = { fontSize: "16px", maxWidth: "520px", lineHeight: 1.5, margin: 0 };
const noteStyle = { fontSize: "13px", color: "#8a94a6", marginTop: "20px" };

function Maintenance() {
    return (
        <div style={wrapStyle} role="alert" aria-live="polite">
            <h1 style={headingStyle}>Currently Under Maintenance</h1>
            <p style={bodyStyle}>
                WebCM is temporarily unavailable while we perform maintenance.
                We&rsquo;ll be back shortly &mdash; this page will reconnect automatically
                once service is restored.
            </p>
            <p style={noteStyle}>No action is needed on your part.</p>
        </div>
    );
}

export default Maintenance;
